import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal } from '../../../../../components/ui/Modal';
import { BultoLogisticsForm } from '../../../../../components/deliveries/BultoLogisticsForm';
import { useWeightUnit } from '../../../../../features/deliveryItems/weightUnit';

/**
 * Captures the weight, the dimensions and the contents of one bulto.
 *
 * The form, and every rule in it, is `BultoLogisticsForm`, shared with the
 * bultos modal of the deliveries listing; this is only the dialog around it.
 *
 * @param {object} props
 * @param {object|null} props.item - The bulto being edited.
 * @param {() => void} props.onClose
 * @param {object} props.order
 * @param {(message: string) => void} props.onError
 */
const EditLogisticsModal = ({ item, onClose, order, onError }) => {
  const { data: items } = useSelector((state) => state.deliveryItems);
  const [saving, setSaving] = useState(false);
  // Kilos by default, grams on request; the same choice the listing's modal reads.
  const [weightUnit, setWeightUnit] = useWeightUnit();

  if (!item) return null;

  return (
    <Modal isOpen onClose={onClose} title="Variables logísticas" busy={saving}>
      <p className="text-sm text-text-secondary text-center -mt-6 mb-6">
        Bulto {item.item_index} de {item.total_items}
      </p>
      <BultoLogisticsForm
        item={item}
        items={items}
        orderProducts={order.products || []}
        deliveryId={order.delivery?.id}
        onSaved={onClose}
        onCancel={onClose}
        onError={onError}
        onBusyChange={setSaving}
        unit={weightUnit}
        onUnitChange={setWeightUnit}
      />
    </Modal>
  );
};

export default EditLogisticsModal;
